import request from '@/utils/request';


export const getStandardList = (url) => {
  return request({
    url: '/jdc-data/inclusioncriteria/list',
    method: 'get',
  })
}

export const getIndexNewsList = (sortIndex) => {
  return request({
    url: `/jdc-data/blog/list?current=1&size=4&category=${sortIndex+1}`,
    method: 'get',
  })
}